module.exports = __webpack_public_path__ + "assets/img/17-m.76efea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/17-m.jpg
// module id = muMd
// module chunks = 0